export var PageId;
(function(PageId) {
    PageId["Activity"] = "mrkt/team-management/activity";
    PageId["AddTeam"] = "mrkt/add-team";
    PageId["ArtistAudience"] = "mrkt/artist/audience";
    PageId["ArtistAudienceEngagement"] = "mrkt/artist/audience/engagement";
    PageId["ArtistAudienceReleaseEngagement"] = "mrkt/artist/audience/release-engagement";
    PageId["ArtistAudienceSourceOfStreams"] = "mrkt/artist/audience/source-of-streams";
    PageId["ArtistAudienceDemographic"] = "mrkt/artist/audience/demographic";
    PageId["ArtistAudienceLocation"] = "mrkt/artist/audience/location";
    PageId["ArtistAudienceSimilarArtists"] = "mrkt/artist/audience/similar-artists";
    PageId["ArtistContentMismatch"] = "mrkt/content-mismatch";
    PageId["ArtistDistributorInvite"] = "mrkt/distributor-invite";
    PageId["ArtistHome"] = "mrkt/artist/home";
    PageId["ArtistMusic"] = "mrkt/artist/music";
    PageId["ArtistNMS"] = "mrkt/artist/nms";
    PageId["ArtistNMSCreate"] = "mrkt/artist/nms/create";
    PageId["ArtistNMSEdit"] = "mrkt/artist/nms/edit";
    PageId["ArtistPlaylists"] = "mrkt/artist/playlists";
    PageId["ArtistProfile"] = "mrkt/artist/profile";
    PageId["ArtistProfileAbout"] = "mrkt/artist/profile/about";
    PageId["ArtistProfileConcerts"] = "mrkt/artist/profile/concerts";
    PageId["ArtistProfileFundraising"] = "/mrkt/artist/profile/fundraising";
    PageId["ArtistProfileImagesEdit"] = "mrkt/artist/profile/images/edit";
    PageId["ArtistProfilePlaylists"] = "mrkt/artist/profile/playlists";
    PageId["ArtistProfileMerch"] = "mrkt/artist/profile/merch";
    PageId["ArtistReleases"] = "mrkt/artist/releases";
    PageId["ArtistReleaseStats"] = "mrkt/artist/release/stats";
    PageId["ArtistSongPlaylists"] = "mrkt/artist/song/playlists";
    PageId["ArtistSongStats"] = "mrkt/artist/song/stats";
    PageId["ArtistSongs"] = "mrkt/artist/songs";
    PageId["ArtistUpcoming"] = "mrkt/artist/upcoming";
    PageId["ArtistCampaigns"] = "mrkt/artist/campaigns";
    PageId["ArtistCampaignsTeam"] = "mrkt/artist/campaigns/team";
    PageId["ArtistCampaignsPreview"] = "mrkt/artist/campaigns/preview";
    PageId["ArtistCampaignsSetup"] = "mrkt/artist/campaigns/setup";
    PageId["ArtistCampaignsBudget"] = "mrkt/artist/campaigns/budget";
    PageId["ArtistCampaignsBilling"] = "mrkt/artist/campaigns/billing";
    PageId["ArtistCampaignsReview"] = "mrkt/artist/campaigns/review";
    PageId["ArtistCampaignsSuccess"] = "mrkt/artist/campaigns/success";
    PageId["ArtistCampaignsDetail"] = "mrkt/artist/campaigns/detail";
    PageId["ArtistCampaignsDraft"] = "mrkt/artist/campaigns/draft";
    PageId["ArtistCampaignAdmin"] = "mrkt/artist/campaign-admin";
    PageId["ArtistCampaignsDiscoveryMode"] = "mrkt/artist/campaigns/dm";
    PageId["ArtistCampaignsDiscoveryModeReport"] = "mrkt/artist/campaigns/dm/report";
    PageId["ArtistCampaignsNoArtistRedirect"] = "mrkt/artist/campaigns/no-artist-redirect";
    PageId["Billing"] = "mrkt/team-management/billing";
    PageId["NotFound"] = "mrkt/not-found";
    PageId["Roster"] = "mrkt/roster";
    PageId["TeamAccessArtist"] = "mrkt/team/access/artist";
    PageId["TeamAccessLabel"] = "mrkt/team/access/label";
    PageId["TeamLabelArtists"] = "mrkt/team/label/artists";
    PageId["TeamManagement"] = "mrkt/team-management";
    PageId["TeamManagementAcceptInvite"] = "mrkt/team-management/accept-invite";
    PageId["TeamManagementBulkInvite"] = "mrkt/team-management/bulk-invite";
    PageId["TeamManagementDetails"] = "mrkt/team-management/details";
    PageId["TeamManagementTeamDetails"] = "mrkt/team-management/team-details";
    PageId["TeamManagementInvite"] = "mrkt/team-management/invite";
    PageId["TeamManagementYourTeams"] = "mrkt/team-management/select-team";
    PageId["UserSettings"] = "mrkt/user-settings";
    PageId["FanEngagement"] = "mrkt/fan-engagement";
    PageId["LiveArtistRoomCreate"] = "mrkt/live-artist-room/create";
    PageId["LiveArtistRoomEdit"] = "mrkt/live-artist-room/edit";
    PageId["VideoDashboard"] = "mrkt/video";
    PageId["VideoCreate"] = "mrkt/video/create";
    PageId["VideoEdit"] = "mrkt/video/edit";
    PageId["VideoWrapped"] = "mrkt/video/wrapped";
    PageId["Wrapped"] = "mrkt/wrapped";
})(PageId || (PageId = {}));
